class PanelLayout {
  constructor(events, stats) {
    this.events = events;
    this.stats = stats;
  }

  resizeEvents(action) {
    this.events = action;
    this.stats = this.flipInactivePanel(action);
  }

  resizeStats(action) {
    this.events = this.flipInactivePanel(action);
    this.stats = action;
  }

  flipInactivePanel(action) {
    if (action === PanelLayout.MAX) {
      return PanelLayout.MIN;
    } else if (action === PanelLayout.MIN) {
      return PanelLayout.MAX;
    } else {
      return PanelLayout.FIT;
    }
  }

  isStatsMin() {
    return this.stats === PanelLayout.MIN;
  }

  isStatsMax() {
    return this.stats === PanelLayout.MAX;
  }

  isEventsMin() {
    return this.events === PanelLayout.MIN;
  }

  isEventsMax() {
    return this.events === PanelLayout.MAX;
  }
}

PanelLayout.MAX = 0;
PanelLayout.MIN = 1;
PanelLayout.FIT = 2;

export default PanelLayout;
